import { SmartDmMeasurementParser } from './SmartDmMeasurementParser';
import type { ParsedData } from '../../../../interfaces/toolData';

/**
 * Parser for JAE Smart DM GAMMA files
 * 
 * Handles gamma ray measurements including:
 * - BULK_GAMMA_CORRECTED
 * - FOCUSED_GAMMA_1_CORRECTED  
 * - FOCUSED_GAMMA_2_CORRECTED
 */
export class SmartDmGammaParser {
  static parse(fileContent: string): ParsedData {
    const unitMappings = {
      'BULK_GAMMA_CORRECTED': 'API',
      'FOCUSED_GAMMA_1_CORRECTED': 'API',
      'FOCUSED_GAMMA_2_CORRECTED': 'API'
    };
    
    return SmartDmMeasurementParser.parse(
      fileContent,
      'GAMMA',
      'JAE_SMARTDM_GAMMA',
      unitMappings
    );
  }
} 